import type { HTMLAttributes } from 'react';
import { cx } from '../utils/cx.js';
import styles from './Progress.module.css';

export type ProgressProps = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
  value: number;
  /** 0–100 */
  max?: number;
  tone?: 'success' | 'danger' | 'neutral';
  size?: 'sm' | 'md';
};

export function Progress({ value, max = 100, tone = 'neutral', size = 'sm', className, ...rest }: ProgressProps) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div className={cx(styles.track, styles[`size_${size}`], className)} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} {...rest}>
      <div className={cx(styles.bar, styles[`tone_${tone}`])} style={{ width: `${pct}%` }} />
    </div>
  );
}
